<max-loader-text [title]=""></max-loader-text>
<app-load-style [styleList]="styleLinks"></app-load-style>
